let store = require("../store");
let actions = require("../actions");

let SubjectRecordings = require("../widget/SubjectRecordings");
let SubjectAnnotations = require("../widget/SubjectAnnotations");

let Tabs = mc.widgets.Tabs;
let IconButton = mc.widgets.IconButton;

class SubjectData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      term: this.props.term || "",
      prefs: store.getState().prefs
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState({
      prefs: store.getState().prefs
    });
  }

  setType(type, changed) {
    if (changed) {
      actions.setPref("subjectDataFilter", type);
    }
  }

  setTerm(evt) {
    let term = evt.target.value;

    this.setState({ term });
  }

  setSort(key, direction) {
    actions.setPref("dateSortDirection", direction);
  }

  downloadAnnotations(evt) {
    let { subject } = this.props;

    let url = `/archives/${subject.studyId}/subjects/${subject.id}/annotations`;
    let fileName = encodeURIComponent(subject.displayName) + "_annotations.csv";

    mc.ajax.get(url).then(function (text) {
      mc.file.download(fileName, "text/csv", text);
    }).catch(function (err) {
      mc.ui.alert(err.message);
    });
  }

  render() {
    let { subject, annotations, activities, isModal } = this.props;
    let { term, prefs } = this.state;

    let direction = prefs.dateSortDirection || 1;
    let types = ["recordings", "activities", "diaries", "labels"];
    let type = types.includes(prefs.subjectDataFilter) ? prefs.subjectDataFilter : "recordings";

    let opts = types.map(function (opt) {
      return { value: opt, label: tx(opt) };
    });

    return (
      <div className="rc-subject-data">
        <div className="rc-subject-data-controls mc-split-layout">
          <div>
            <Tabs
              options={opts}
              value={type}
              rounded={true}
              onSelect={this.setType.bind(this)}/>
            <input
              type="search"
              onChange={this.setTerm.bind(this)}
              placeholder={tx("search")}/>
          </div>
          {!isModal ? (
            <IconButton
              icon="download"
              id="download_annos_csv"
              scale={1.2}
              label={tx("all_annos_csv")}
              disabled={annotations.length === 0}
              onPress={this.downloadAnnotations.bind(this)}/>
          ) : null}
        </div>
        <div>
          {type === "recordings" ? (
            <SubjectRecordings
              subject={subject}
              term={term}
              direction={direction}
              onSort={this.setSort.bind(this)}
              isModal={isModal}/>
          ) : (
            <SubjectAnnotations
              subject={subject}
              category={type}
              term={term}
              annotations={annotations}
              activities={activities}
              direction={direction}
              onSort={this.setSort.bind(this)}
              isModal={isModal}/>
          )}
        </div>
      </div>
    );
  }
}

module.exports = SubjectData;